import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PORTAL_TITLES = [
  { prefix: '/client', title: 'MAD Donuts Wholesale Client Portal' },
  { prefix: '/admin', title: 'MAD Donuts Admin Portal' },
  { prefix: '/staff', title: 'MAD Donuts Bakery Portal' },
];

/**
 * Titles for the protected portals only — public pages are owned by <Seo>,
 * which sets a unique, search-friendly title per URL.
 */
const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const match = PORTAL_TITLES.find((entry) => location.pathname.startsWith(entry.prefix));
    if (match) document.title = match.title;
  }, [location.pathname]);
};

export default usePageTitle;
